import React from 'react';

const Founder = () => {
    return (
        <div className="pt-0 md:pt-40">
            <div className="bg-gradient-to-r from-[#fbf9f6] via-[#fef8f2] to-[#fffcee] pt-80 pb-80 custom-padding xl-screen-padding">
                <div className="mx-auto grid grid-cols-1 md:grid-cols-2 items-center gap-8 px-0">
                    <div className="space-y-6">
                        <h1 className="text-4xl md:text-4xl font-semibold text-gray-800 font-merriweather">
                            Meet the <span className="text-[#C7A26B]">Founder</span>
                        </h1>
                        <p className="text-sm md:text-lg text-gray-600 font-lato">
                            Internationally Certified Body Anatomist & Nutritionist | Founder & MD, Nutrillion.
                        </p>
                        <div className="w-60 h-0.5 bg-gray-400"></div>
                        <p className="text-[#6f787e] text-base md:text-lg font-lato">
                            The Visionary Leader Transforming Lives through Personalized Nutrition Consultation.
                        </p>
                        <p className="text-[#6f787e] text-base md:text-lg font-lato">
                            Dr. Rishabh Verma is an innovative entrepreneur reshaping the health
                            and wellness landscape through personalized nutrition. From a successful investment banking career to
                            pioneering transformative healthcare, his journey is driven by passion and purpose.
                        </p>
                        <p className="text-[#6f787e] text-base md:text-lg font-lato">
                            As the Founder of Nutrillion, Dr. Verma combines advanced nutritional science with state-of-the-art technology
                            to offer tailored health solutions, working towards a disease-free society. Holding esteemed certifications, his
                            commitment to health transformation is unwavering.
                        </p>
                    </div>
                    <div className="flex justify-center items-center ">
                        <div className="relative">
                            <img
                                src={require("../../src/assets/images/image_111.png")}
                                alt="Nutrigenomics Experts"
                                className="relative z-10 rounded-[50px] founder shadow-xl object-cover md:-mt-44 mt-0"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Founder;
